export default __webpack_public_path__ + "static/media/avatar_10_2.54a9562a.png";